import clsx from 'clsx';

import { WorkspaceFolderIcon } from '@app/components/icon-list/icons';

import { BreadCrumbDropdown } from '../bread-crumb-dropdown';
import BreadCrumbLink from '../bread-crumb-link';
import style from '../bread-crumb.module.scss';
import type { BreadCrumbLink as BreadCrumbLinkType } from '../types';

const MAX_VISIBLE_BREADCRUMB_LINKS = 2;
const lastLinkIndex = -1;

type Props = {
  links?: BreadCrumbLinkType[];
  onBreadCrumbItemClick?: (id?: number) => void;
  showLastBreadCrumbLink?: boolean;
  customBreadCrumbDropdownClassName?: string;
};

export const FolderBreadCrumb = ({
  links = [],
  onBreadCrumbItemClick,
  showLastBreadCrumbLink = false,
  customBreadCrumbDropdownClassName,
}: Props) => {
  const shouldShowDropdown = links.length > MAX_VISIBLE_BREADCRUMB_LINKS;

  let linksArray = links.slice(1);

  if (shouldShowDropdown) {
    const lastLink = links.slice(lastLinkIndex);
    linksArray = lastLink;
  }

  const isLastBreadCrumbLink = (index: number) => index === linksArray.length - 1;

  return (
    <div className={clsx(style.BreadCrumb, style.FolderBreadCrumbContainer)}>
      <div className={style.BreadCrumbDropdownContainer}>
        <WorkspaceFolderIcon
          height="16px"
          width="16px"
        />
        <BreadCrumbLink
          isBreadCrumbInFolderCard={false}
          isFolderBreadCrumb
          isLastBreadCrumbLink={linksArray.length === 0}
          isSearchedFolderBreadcrumb={false}
          onClickHandler={() => onBreadCrumbItemClick?.(links[0]?.id)}
          key={links[0].id}
          {...links[0]}
        />
        {shouldShowDropdown && (
          <>
            <BreadCrumbDropdown
              links={links.slice(1, lastLinkIndex)}
              onDropdownItemClick={onBreadCrumbItemClick}
              DropdownItemClassName={customBreadCrumbDropdownClassName}
            />
            <span
              className={style.BreadCrumbDropdownDivider}
              data-testid="BreadCrumbDropdownDivider"
            >
              /
            </span>
          </>
        )}
      </div>
      {linksArray.map((link, index) => {
        if (onBreadCrumbItemClick && (!isLastBreadCrumbLink(index) || showLastBreadCrumbLink)) {
          return (
            <BreadCrumbLink
              isFolderBreadCrumb
              isLastBreadCrumbLink={isLastBreadCrumbLink(index)}
              key={link.id}
              onClickHandler={() => onBreadCrumbItemClick(link.id)}
              {...link}
            />
          );
        }

        return (
          <BreadCrumbLink
            isBreadCrumbInFolderCard={false}
            isFolderBreadCrumb
            isLastBreadCrumbLink={isLastBreadCrumbLink(index)}
            isSearchedFolderBreadcrumb={false}
            key={link.id}
            {...link}
          />
        );
      })}
    </div>
  );
};
